module.exports = __webpack_public_path__ + "static/bahamut-as-fizban-helps-1612b1d9836a27d6cacae403ebacef19.jpg";